'use strict';

(function() {
	// In this controller we will receive events emitted by the various components (observers) and then broadcast events as
	// necessary (which may be different).
	// So this controller is like the Subject in the Subject-Observer design pattern (see Gamma et al.)
	// Instead, we could have used $rootScope to broadcast the events directly from the components but the approach
	// of having a separate "subject" has more flexibility because the subject can contain state and make decisions to
	// send a different message (or no message) out to the observers.
	angular.module('onboarding.common')
		.directive('cobSubject', cobSubject);

	cobSubject.$inject = ['$log', '$timeout', 'subjectObserverMessagesService', '$location', '$cookies'];

	var observerMessageLookup = {};
	var $log, $timeout, subjectObserverMessagesService, $location, $cookies;
	var subjectMessages, observerMessages, sharedApplicationState;
	var DELAY = 800;

	function cobSubject(_$log_, _$timeout_, _subjectObserverMessagesService_, _$location_, _$cookies_) {
		$log = _$log_;
		$timeout = _$timeout_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		$location = _$location_;
		$cookies = _$cookies_;

		return {
			restrict: 'A',
			scope: false,
			replace: true,
			link: linkFunction
		};
	}

	// There will be only 1 instance of this directive on the page
	function linkFunction(scope, elem, attrs) {

		observerMessageLookup = subjectObserverMessagesService.getObserverMessageLookup();
		subjectMessages = subjectObserverMessagesService.getSubjectMessages();
		observerMessages = subjectObserverMessagesService.getObserverMessages();

		observerMessageLookup[subjectMessages
			.COB_SUBJECT_SETTINGS_DATA_LOADED] = observerMessages.COB_OBSERVER_SETTINGS_DATA_LOADED;
		activate();

		////////////////////

		function activate() {
			for (var message in subjectMessages) {
				if (Object.prototype.hasOwnProperty.call(subjectMessages, message)) { //skip inherited
					scope.$on(subjectMessages[message], sendMessageToObservers);
				}
			}

			sharedApplicationState = {
				userName: '',
				subscription: '',
				capabilities: [],
			};
			determineCapabilities();
		}

		function determineCapabilities() {
			var cobCookieValue = $cookies.DOB;
		}

		function registerApplicationState(event, subjectMessage, data) {
			sharedApplicationState.userName = data.session.userName;
			sharedApplicationState.capabilities = data.session.capabilityIds;

			sendMessageToObservers(Event, subjectMessage, data);
			///sendMessageToObservers(event, subjectMessages.COB_SUBJECT_LOGIN_FINISHED_SUCCESS, sharedApplicationState);
		}

		function sendMessageToObservers(event, subjectMessage, data) {
			$log.debug('Subject received message: ' + subjectMessage + ' with data: ' + data);
			event.stopPropagation && event.stopPropagation();
			var observerMessage = observerMessageLookup[subjectMessage];
			if (!observerMessage) {
				var errorMsg = 'Unknown subject message: ' + subjectMessage;
				$log.error(errorMsg);
				throw errorMsg;
			}
			scope.$broadcast(observerMessage, observerMessage, data);
		}

	}
})();
